export const BRANDS_FETCH_STARTED = 'BRANDS_FETCH_STARTED';
export const BRANDS_FETCH_COMPLETED = 'BRANDS_FETCH_COMPLETED';
export const BRANDS_FETCH_FAILED = 'BRANDS_FETCH_FAILED';
